export default __webpack_public_path__ + "static/teacher2-998985517895d2a5321c334338d97905.png";